module.exports = __webpack_public_path__ + "static/img/Hayden-Young.0e58275.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Hayden-Young.jpg
// module id = bIFd
// module chunks = 0